module.exports = __webpack_public_path__ + "img/nbus_container_3_left.a2e52ec4.jpg";